<template>
	<div>
		<div ref='component' id="myChart2"></div>
	</div>
</template>

<script>
import { post } from "@/api/requrestHttp";
import { ConsultList } from '../../../platform/provideManage/api';
export default {
    props: ['dataTime'],
    data() {
		this.isEchart = ''
		return {
            usernameLsit:[],
            percentList:[],
        }
	},
    watch: {
		dataTime() {
			this.getPlayback()
		}
	},
    created() {

	},
	mounted() {
		// this.getPlayback()
	},
    methods: {
        async getPlayback() {
            console.log(this.dataTime, 'aaaa')
			const res = await post("/jjyl/callInfo/info/findCallInfo", {
				belongAddressId: '4812088f-d02b-4cbe-8dfe-55ad8813df23',
				pageSize: 1000,
				pageNo: 1,
				startTime: this.dataTime[0],
				endTime: this.dataTime[1],
				isCall:1,
			});
			//   console.log(res,"afdsa");
			const { code, content } = res;
			console.log(res.content,"asadc")
			if (code === 200) {
			    this.usernameLsit = content.list.filter(isat =>{
					if(isat.username){
						return isat.username
					}
				}).map(isDate =>{
					return isDate.username
				})
                this.percentList = content.list.filter(isat =>{
					if(isat.username){
						return isat.percent
					}
                    if(isat.percent==''){
                        isat.percent==0
                        return isat.percent
                    }
				}).map(isDate =>{
                    console.log(isDate.percent)
                    console.log(isDate.percent.substr(0, isDate.percent.length - 2), 'aaaa')
					return isDate.percent.substr(0, isDate.percent.length - 2)
                    
				})
            }
            this.drawLine(this.usernameLsit,this.percentList)
        },
        drawLine(usernameLsit,percentList){
            this.isEchart = this.$echarts.init(document.getElementById('myChart2'));
			this.$echarts.init(this.$refs.component, null, {
				renderer: 'canvas'
			})
            this.isEchart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data:usernameLsit,
                        // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '接通率',
                        type: 'bar',
                        barWidth: '60%',
                        data: percentList
                    }
                ]
            })
        }
    },
    beforeDestroy() {
		if (this.isEchart) {
			this.isEchart.clear();
		}
	}
}
</script>

<style lang="less" scoped>
    #myChart2 {
		width: 100%;
		height: 460px;
	}
</style>